module.exports = __webpack_public_path__ + "assets/images/megaphone_purple.svg?7f2b203c3be407162a0c6b53e10709c1";


//////////////////
// WEBPACK FOOTER
// ./_source/images/icons/sessions/megaphone_purple.svg
// module id = 622
// module chunks = 0